/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminMatchDashboardGigsCandidatesRetrieveParams,
  AdminMatchDashboardGigsGrantedProsRetrieveParams,
  AdminMatchDashboardGigsListParams,
  AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams,
  AdminMatchDashboardGigsPossibleMatchesRetrieveParams,
  AdminMatchDashboardGigsSummaryRetrieveParams,
  AdminMatchDashboardGigsWaitlistedProsRetrieveParams,
  LastCallCohortPreview,
  MatchDashboardCandidatesPaginatedResponse,
  MatchDashboardFilterOptions,
  MatchDashboardGigDetail,
  MatchDashboardGrantedProsPaginatedResponse,
  MatchDashboardPossibleMatchesPaginatedResponse,
  MatchDashboardPossibleMatchesProIdsResponse,
  MatchDashboardSummary,
  MatchDashboardWaitlistedProsPaginatedResponse,
  PaginatedMatchDashboardGigListList,
  RemindPreview
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAdminMatchDashboardGigsListUrl = (params?: AdminMatchDashboardGigsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/gigs/?${stringifiedParams}` : `/api/admin/match-dashboard/gigs/`
}

/**
 * Read-only Match V3 Command Center endpoints for gigs and candidates.
 *
 * Write actions (direct offer, toggle auto-select, set bonus, dismiss,
 * remind) intentionally live elsewhere so there's only one write surface
 * per domain. See DASHBOARD_WRITE_ACTIONS.md for the endpoint mapping.
 */
export const adminMatchDashboardGigsList = async (params?: AdminMatchDashboardGigsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedMatchDashboardGigListList> => {

  return customFetch<PaginatedMatchDashboardGigListList>(getAdminMatchDashboardGigsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsListInfiniteQueryKey = (params?: AdminMatchDashboardGigsListParams,) => {
    return [
    'infinite', `/api/admin/match-dashboard/gigs/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminMatchDashboardGigsListQueryKey = (params?: AdminMatchDashboardGigsListParams,) => {
    return [
    `/api/admin/match-dashboard/gigs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardGigsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, AdminMatchDashboardGigsListParams['page']>, TError = void>(params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData, QueryKey, AdminMatchDashboardGigsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, QueryKey, AdminMatchDashboardGigsListParams['page']> = ({ signal, pageParam }) => adminMatchDashboardGigsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData, QueryKey, AdminMatchDashboardGigsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>>
export type AdminMatchDashboardGigsListInfiniteQueryError = void


export function useAdminMatchDashboardGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, AdminMatchDashboardGigsListParams['page']>, TError = void>(
 params: undefined |  AdminMatchDashboardGigsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData, QueryKey, AdminMatchDashboardGigsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, AdminMatchDashboardGigsListParams['page']>, TError = void>(
 params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData, QueryKey, AdminMatchDashboardGigsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, AdminMatchDashboardGigsListParams['page']>, TError = void>(
 params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData, QueryKey, AdminMatchDashboardGigsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, AdminMatchDashboardGigsListParams['page']>, TError = void>(
 params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData, QueryKey, AdminMatchDashboardGigsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsListQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError = void>(params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>> = ({ signal }) => adminMatchDashboardGigsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>>
export type AdminMatchDashboardGigsListQueryError = void


export function useAdminMatchDashboardGigsList<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError = void>(
 params: undefined |  AdminMatchDashboardGigsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsList<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError = void>(
 params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsList<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError = void>(
 params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsList<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError = void>(
 params?: AdminMatchDashboardGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsRetrieveUrl = (id: number,) => {




  return `/api/admin/match-dashboard/gigs/${id}/`
}

/**
 * Read-only Match V3 Command Center endpoints for gigs and candidates.
 *
 * Write actions (direct offer, toggle auto-select, set bonus, dismiss,
 * remind) intentionally live elsewhere so there's only one write surface
 * per domain. See DASHBOARD_WRITE_ACTIONS.md for the endpoint mapping.
 */
export const adminMatchDashboardGigsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardGigDetail> => {

  return customFetch<MatchDashboardGigDetail>(getAdminMatchDashboardGigsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/`
    ] as const;
    }


export const getAdminMatchDashboardGigsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>> = ({ signal }) => adminMatchDashboardGigsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>>
export type AdminMatchDashboardGigsRetrieveQueryError = void


export function useAdminMatchDashboardGigsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsCandidatesRetrieveUrl = (id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/gigs/${id}/candidates/?${stringifiedParams}` : `/api/admin/match-dashboard/gigs/${id}/candidates/`
}

/**
 * Read-only Match V3 Command Center endpoints for gigs and candidates.
 *
 * Write actions (direct offer, toggle auto-select, set bonus, dismiss,
 * remind) intentionally live elsewhere so there's only one write surface
 * per domain. See DASHBOARD_WRITE_ACTIONS.md for the endpoint mapping.
 */
export const adminMatchDashboardGigsCandidatesRetrieve = async (id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardCandidatesPaginatedResponse> => {

  return customFetch<MatchDashboardCandidatesPaginatedResponse>(getAdminMatchDashboardGigsCandidatesRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsCandidatesRetrieveInfiniteQueryKey = (id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams,) => {
    return [
    'infinite', `/api/admin/match-dashboard/gigs/${id}/candidates/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminMatchDashboardGigsCandidatesRetrieveQueryKey = (id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/candidates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardGigsCandidatesRetrieveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsCandidatesRetrieveInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, QueryKey, AdminMatchDashboardGigsCandidatesRetrieveParams['page']> = ({ signal, pageParam }) => adminMatchDashboardGigsCandidatesRetrieve(id,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsCandidatesRetrieveParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsCandidatesRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>>
export type AdminMatchDashboardGigsCandidatesRetrieveInfiniteQueryError = void


export function useAdminMatchDashboardGigsCandidatesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsCandidatesRetrieveParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsCandidatesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsCandidatesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsCandidatesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsCandidatesRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsCandidatesRetrieveInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsCandidatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsCandidatesRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>> = ({ signal }) => adminMatchDashboardGigsCandidatesRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsCandidatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>>
export type AdminMatchDashboardGigsCandidatesRetrieveQueryError = void


export function useAdminMatchDashboardGigsCandidatesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsCandidatesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsCandidatesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsCandidatesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsCandidatesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsCandidatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsCandidatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsCandidatesRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsGrantedProsRetrieveUrl = (id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/gigs/${id}/granted-pros/?${stringifiedParams}` : `/api/admin/match-dashboard/gigs/${id}/granted-pros/`
}

/**
 * Pros on the shift's admin DO grants who have no application on it, as candidate-like rows.
 */
export const adminMatchDashboardGigsGrantedProsRetrieve = async (id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardGrantedProsPaginatedResponse> => {

  return customFetch<MatchDashboardGrantedProsPaginatedResponse>(getAdminMatchDashboardGigsGrantedProsRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsGrantedProsRetrieveInfiniteQueryKey = (id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams,) => {
    return [
    'infinite', `/api/admin/match-dashboard/gigs/${id}/granted-pros/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminMatchDashboardGigsGrantedProsRetrieveQueryKey = (id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/granted-pros/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardGigsGrantedProsRetrieveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsGrantedProsRetrieveInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, QueryKey, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']> = ({ signal, pageParam }) => adminMatchDashboardGigsGrantedProsRetrieve(id,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsGrantedProsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>>
export type AdminMatchDashboardGigsGrantedProsRetrieveInfiniteQueryError = void


export function useAdminMatchDashboardGigsGrantedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsGrantedProsRetrieveParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsGrantedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsGrantedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsGrantedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsGrantedProsRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsGrantedProsRetrieveInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsGrantedProsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsGrantedProsRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>> = ({ signal }) => adminMatchDashboardGigsGrantedProsRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsGrantedProsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>>
export type AdminMatchDashboardGigsGrantedProsRetrieveQueryError = void


export function useAdminMatchDashboardGigsGrantedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsGrantedProsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsGrantedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsGrantedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsGrantedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsGrantedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsGrantedProsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsGrantedProsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsLastCallPreviewRetrieveUrl = (id: number,) => {




  return `/api/admin/match-dashboard/gigs/${id}/last-call-preview/`
}

/**
 * What a Last Call blast for this shift would do right now (CORE-7743).
 *
 * Read-only: previewing never writes, so it cannot persist a config the ops user has not saved.
 * ``select_related`` covers what the resolver and the pacing derivation read off the row; the
 * prefetches cover the certifications ``LastCallPolicy.imposes`` checks when conversion offers are on.
 */
export const adminMatchDashboardGigsLastCallPreviewRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<LastCallCohortPreview> => {

  return customFetch<LastCallCohortPreview>(getAdminMatchDashboardGigsLastCallPreviewRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsLastCallPreviewRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/last-call-preview/`
    ] as const;
    }


export const getAdminMatchDashboardGigsLastCallPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsLastCallPreviewRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>> = ({ signal }) => adminMatchDashboardGigsLastCallPreviewRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsLastCallPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>>
export type AdminMatchDashboardGigsLastCallPreviewRetrieveQueryError = void


export function useAdminMatchDashboardGigsLastCallPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsLastCallPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsLastCallPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsLastCallPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsLastCallPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsLastCallPreviewRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsPossibleMatchesRetrieveUrl = (id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/gigs/${id}/possible-matches/?${stringifiedParams}` : `/api/admin/match-dashboard/gigs/${id}/possible-matches/`
}

/**
 * Paginated, filterable pool of pros for a gig; broad mode's ``count`` is capped (``count_is_capped``).
 */
export const adminMatchDashboardGigsPossibleMatchesRetrieve = async (id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardPossibleMatchesPaginatedResponse> => {

  return customFetch<MatchDashboardPossibleMatchesPaginatedResponse>(getAdminMatchDashboardGigsPossibleMatchesRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsPossibleMatchesRetrieveInfiniteQueryKey = (id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams,) => {
    return [
    'infinite', `/api/admin/match-dashboard/gigs/${id}/possible-matches/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminMatchDashboardGigsPossibleMatchesRetrieveQueryKey = (id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/possible-matches/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardGigsPossibleMatchesRetrieveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsPossibleMatchesRetrieveInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, QueryKey, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']> = ({ signal, pageParam }) => adminMatchDashboardGigsPossibleMatchesRetrieve(id,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsPossibleMatchesRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>>
export type AdminMatchDashboardGigsPossibleMatchesRetrieveInfiniteQueryError = void


export function useAdminMatchDashboardGigsPossibleMatchesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsPossibleMatchesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsPossibleMatchesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsPossibleMatchesRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsPossibleMatchesRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsPossibleMatchesRetrieveInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsPossibleMatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsPossibleMatchesRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>> = ({ signal }) => adminMatchDashboardGigsPossibleMatchesRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsPossibleMatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>>
export type AdminMatchDashboardGigsPossibleMatchesRetrieveQueryError = void


export function useAdminMatchDashboardGigsPossibleMatchesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsPossibleMatchesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsPossibleMatchesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsPossibleMatchesRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsPossibleMatchesRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsPossibleMatchesProIdsRetrieveUrl = (id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/gigs/${id}/possible-matches/pro-ids/?${stringifiedParams}` : `/api/admin/match-dashboard/gigs/${id}/possible-matches/pro-ids/`
}

/**
 * Every pro id the Possible Matches filters match, in list order, up to the Select all cap (CORE-8732).
 */
export const adminMatchDashboardGigsPossibleMatchesProIdsRetrieve = async (id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardPossibleMatchesProIdsResponse> => {

  return customFetch<MatchDashboardPossibleMatchesProIdsResponse>(getAdminMatchDashboardGigsPossibleMatchesProIdsRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsPossibleMatchesProIdsRetrieveQueryKey = (id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/possible-matches/pro-ids/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardGigsPossibleMatchesProIdsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsPossibleMatchesProIdsRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>> = ({ signal }) => adminMatchDashboardGigsPossibleMatchesProIdsRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>>
export type AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveQueryError = void


export function useAdminMatchDashboardGigsPossibleMatchesProIdsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsPossibleMatchesProIdsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsPossibleMatchesProIdsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsPossibleMatchesProIdsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsPossibleMatchesProIdsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsPossibleMatchesProIdsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsPossibleMatchesProIdsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsRemindPreviewRetrieveUrl = (id: number,) => {




  return `/api/admin/match-dashboard/gigs/${id}/remind-preview/`
}

/**
 * The remind dialog's prefill, audience sizes and cooldown (CORE-8433). Read-only.
 */
export const adminMatchDashboardGigsRemindPreviewRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RemindPreview> => {

  return customFetch<RemindPreview>(getAdminMatchDashboardGigsRemindPreviewRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsRemindPreviewRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/remind-preview/`
    ] as const;
    }


export const getAdminMatchDashboardGigsRemindPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsRemindPreviewRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>> = ({ signal }) => adminMatchDashboardGigsRemindPreviewRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsRemindPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>>
export type AdminMatchDashboardGigsRemindPreviewRetrieveQueryError = void


export function useAdminMatchDashboardGigsRemindPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsRemindPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsRemindPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsRemindPreviewRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsRemindPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsRemindPreviewRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsWaitlistedProsRetrieveUrl = (id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/gigs/${id}/waitlisted-pros/?${stringifiedParams}` : `/api/admin/match-dashboard/gigs/${id}/waitlisted-pros/`
}

/**
 * Every shift waitlist entry on the gig, any status, newest first (CORE-8715).
 */
export const adminMatchDashboardGigsWaitlistedProsRetrieve = async (id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardWaitlistedProsPaginatedResponse> => {

  return customFetch<MatchDashboardWaitlistedProsPaginatedResponse>(getAdminMatchDashboardGigsWaitlistedProsRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsWaitlistedProsRetrieveInfiniteQueryKey = (id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams,) => {
    return [
    'infinite', `/api/admin/match-dashboard/gigs/${id}/waitlisted-pros/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminMatchDashboardGigsWaitlistedProsRetrieveQueryKey = (id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/gigs/${id}/waitlisted-pros/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardGigsWaitlistedProsRetrieveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsWaitlistedProsRetrieveInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, QueryKey, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']> = ({ signal, pageParam }) => adminMatchDashboardGigsWaitlistedProsRetrieve(id,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsWaitlistedProsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>>
export type AdminMatchDashboardGigsWaitlistedProsRetrieveInfiniteQueryError = void


export function useAdminMatchDashboardGigsWaitlistedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsWaitlistedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsWaitlistedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsWaitlistedProsRetrieveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData, QueryKey, AdminMatchDashboardGigsWaitlistedProsRetrieveParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsWaitlistedProsRetrieveInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsWaitlistedProsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError = void>(id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsWaitlistedProsRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>> = ({ signal }) => adminMatchDashboardGigsWaitlistedProsRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsWaitlistedProsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>>
export type AdminMatchDashboardGigsWaitlistedProsRetrieveQueryError = void


export function useAdminMatchDashboardGigsWaitlistedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError = void>(
 id: number,
    params: undefined |  AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsWaitlistedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsWaitlistedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsWaitlistedProsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError = void>(
 id: number,
    params?: AdminMatchDashboardGigsWaitlistedProsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsWaitlistedProsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsWaitlistedProsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsFilterOptionsRetrieveUrl = () => {




  return `/api/admin/match-dashboard/gigs/filter-options/`
}

/**
 * Read-only Match V3 Command Center endpoints for gigs and candidates.
 *
 * Write actions (direct offer, toggle auto-select, set bonus, dismiss,
 * remind) intentionally live elsewhere so there's only one write surface
 * per domain. See DASHBOARD_WRITE_ACTIONS.md for the endpoint mapping.
 */
export const adminMatchDashboardGigsFilterOptionsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardFilterOptions> => {

  return customFetch<MatchDashboardFilterOptions>(getAdminMatchDashboardGigsFilterOptionsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsFilterOptionsRetrieveQueryKey = () => {
    return [
    `/api/admin/match-dashboard/gigs/filter-options/`
    ] as const;
    }


export const getAdminMatchDashboardGigsFilterOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsFilterOptionsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>> = ({ signal }) => adminMatchDashboardGigsFilterOptionsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsFilterOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>>
export type AdminMatchDashboardGigsFilterOptionsRetrieveQueryError = void


export function useAdminMatchDashboardGigsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsFilterOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsFilterOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardGigsSummaryRetrieveUrl = (params?: AdminMatchDashboardGigsSummaryRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/gigs/summary/?${stringifiedParams}` : `/api/admin/match-dashboard/gigs/summary/`
}

/**
 * Read-only Match V3 Command Center endpoints for gigs and candidates.
 *
 * Write actions (direct offer, toggle auto-select, set bonus, dismiss,
 * remind) intentionally live elsewhere so there's only one write surface
 * per domain. See DASHBOARD_WRITE_ACTIONS.md for the endpoint mapping.
 */
export const adminMatchDashboardGigsSummaryRetrieve = async (params?: AdminMatchDashboardGigsSummaryRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<MatchDashboardSummary> => {

  return customFetch<MatchDashboardSummary>(getAdminMatchDashboardGigsSummaryRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardGigsSummaryRetrieveQueryKey = (params?: AdminMatchDashboardGigsSummaryRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/gigs/summary/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardGigsSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError = void>(params?: AdminMatchDashboardGigsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardGigsSummaryRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>> = ({ signal }) => adminMatchDashboardGigsSummaryRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardGigsSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>>
export type AdminMatchDashboardGigsSummaryRetrieveQueryError = void


export function useAdminMatchDashboardGigsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError = void>(
 params: undefined |  AdminMatchDashboardGigsSummaryRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError = void>(
 params?: AdminMatchDashboardGigsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardGigsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError = void>(
 params?: AdminMatchDashboardGigsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardGigsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError = void>(
 params?: AdminMatchDashboardGigsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardGigsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardGigsSummaryRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






